<template>
  <div>
    <div class="relative ltr">
      <Splide>
        <SplideSlide v-for="slider in sliders" :key="slider.id">
          <img :src="slider.photo.path">
        </SplideSlide>
      </Splide>
    </div>

    <div class="relative bg-gray-900 text-white rounded-t-3xl -mt-10 z-10 p-4">

      <div class="bg-violet-900 rounded-full w-full flex justify-around px-4 py-2 text-xs text-white">
        <div @click="surveyModal = true">
          <MapIcon class="w-5 mx-auto mb-2"/>
          <span>{{ $t('survey') }}</span>
        </div>

        <div class="border border-gray-800"></div>

        <div data-intro="از این قسمت میتوانید تمام خدمات مربوط به اتاق خود را سفارش دهید.">
          <router-link to="/qr">
            <HomeIcon class="w-5 mx-auto mb-2"/>
            <span>{{ $t('room_service') }}</span>
          </router-link>
        </div>

        <div class="border border-gray-800"></div>

        <div>
          <SearchIcon class="w-5 mx-auto mb-2"/>
          <span>{{ $t('search') }}</span>
        </div>
      </div>

      <h1 class="text-lg mt-4">{{ $t('hotel_services') }}</h1>
      <div class="grid grid-cols-3 gap-10 mt-4 text-center">
        <div v-for="service in homepage.services"
             :key="service.id"
             @click="selectedService = service; modalService = true">
          <div class="rounded-full bg-gray-700 p-4 mb-2">
            <img :src="service.photo.path" alt="" class="rounded-full">
          </div>
          <span>{{ service.name }}</span>
        </div>
      </div>

      <h1 class="text-lg mt-4">{{ $t('hotel_products') }}</h1>
      <div class="grid grid-cols-3 gap-10 mt-4 text-center">
        <div v-for="product in homepage.products"
             :key="product.id"
             @click="selectProduct(product)">
          <div class="rounded-full bg-gray-700 p-4 mb-2">
            <img :src="product.photo.path" alt="" class="rounded-full">
          </div>
          <span>{{ product.name }}</span>
        </div>
      </div>

    </div>

    <!--    <router-link to="/qr">-->
    <!--      <img src="../assets/img/banner_room.png" alt="" class="rounded-lg transition"-->
    <!--      @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">-->
    <!--    </router-link>-->

    <SurveyModal
        :show="surveyModal"
        @click="surveyModal = false"
        @created="surveyModal = false"
    />

    <VModal :title="`سفارش ${selectedService.name}`" :show="modalService" @click="modalService = false">
      <div class="overflow-y-scroll flex flex-col h-52">
        <span class="text-sm text-gray-700">{{ selectedService.description }}</span>
        <form @submit.prevent="">
          <VInput class="w-full mt-2" placeholder="تعداد" v-model="serviceRequest.count"
                  type="number" v-if="selectedService.limit_type !== 'none'"/>

          <textarea class="w-full border p-2 rounded-lg text-black mt-2"
                    placeholder="توضیحات..." v-model="serviceRequest.description"></textarea>

          <VButton class="w-full mt-4" @click="submitServiceRequest">ثبت</VButton>
        </form>
      </div>
    </VModal>

    <VModal
        :title="`سفارش ${selectedProduct.name}`"
        :show="modalProduct"
        @click="modalProduct = false">

      <form @submit.prevent="addToCart">
        <div class="flex justify-between items-center">
        <span class="bg-yellow-300 rounded-md p-2"
              @click="incrementCount">+</span>
          <span>{{ selectedProduct.count }}</span>
          <span class="bg-yellow-300 rounded-md p-2"
                @click="decrementCount">-</span>
        </div>

        <textarea class="w-full border p-2 rounded-lg text-black mt-2"
                  placeholder="توضیحات..." v-model="selectedProduct.orderDescription"></textarea>

        <VButton class="w-full mt-4">ثبت</VButton>
      </form>

    </VModal>

  </div>
</template>

<script>
// @ is an alias to /src
import {HomeIcon, MapIcon, SearchIcon} from "@heroicons/vue/outline";

import introJs from 'intro.js'
import "intro.js/minified/introjs.min.css";
import "intro.js/minified/introjs-rtl.min.css";
import {getHomepage, postServiceRequest} from "@/API/API";
import {Splide, SplideSlide} from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import SurveyModal from "@/components/Modal/SurveyModal.vue";
import {mapState} from "vuex";
import VModal from "@/components/General/VModal.vue";
import VButton from "@/components/General/VButton.vue";

export default {
  name: 'HomeView',
  components: {
    VButton,
    VModal,
    SurveyModal,
    HomeIcon,
    MapIcon,
    SearchIcon,
    Splide,
    SplideSlide
  },
  data() {
    return {
      sliders: [],
      homepage: {},
      surveyModal: false,
      language: {},

      modalService: false,
      selectedService: {},
      serviceRequest: {},

      modalProduct: false,
      selectedProduct: {},
    }
  },
  computed: {
    ...mapState(['languages', 'locale'])
  },
  async created() {
    if (this.$route.query.callback === 'cart') {
      this.$cart.value = true
    }

    this.homepage = (await getHomepage()).data
    this.sliders = this.homepage.sliders
  },
  mounted() {
    introJs().setOptions({
      nextLabel: 'بعد',
      prevLabel: 'قبل',
      doneLabel: 'اتمام',
      showProgress: true,
    })
    // .start()
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
    },
    submitServiceRequest() {
      let serviceRequest = {
        'room_number': localStorage.getItem('roomNumber'),
        'service_id': this.selectedService.id,
        'count': this.serviceRequest.count,
        'description': this.serviceRequest.description
      }

      postServiceRequest(serviceRequest)
          .then(() => {
            this.modalService = false
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: 'درخواست با موفقیت ثبت شد.',
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .finally(() => {
            this.modalService = false
            this.serviceRequest = {}
          })

    },
    selectProduct(product) {
      this.selectedProduct = product
      this.selectedProduct.count = this.$store.getters.productCount(this.selectedProduct.id)
      this.selectedProduct.orderDescription = this.$store.getters.productDescription(this.selectedProduct.id)
      this.modalProduct = true
    },

    incrementCount() {
      if (this.selectedProduct.count + 1 > this.selectedProduct.inventory) {
        return
      }
      this.selectedProduct.count++
    },
    decrementCount() {
      if (this.selectedProduct.count - 1 < 0) {
        return
      }
      this.selectedProduct.count--
    },
    addToCart() {
      if (this.selectedProduct.count > 0) {
        this.$store.dispatch('addToCart', this.selectedProduct)
      } else {
        this.$store.dispatch('removeProduct', this.selectedProduct)
      }
      this.modalProduct = false
    },
  },
  watch: {
    languages() {
      this.language = this.languages.find(lang => lang.code === this.locale)
    },
    language() {
      this.$store.dispatch('setLocale', this.language.code)
    },
  }
}
</script>
